import { useModalLogin } from './useModalLogin'

export default useModalLogin
